/* global google */
import { h, Component } from "preact";
import GoogleMap from "react-google-map";
import ReactGoogleMapLoader from "react-google-maps-loader";
import mapMarker from "../assets/images/map-marker.svg";
import config from "../config";

import { css } from "emotion";

const wrapper = css({
  height: 84,
  margin: "12px 0 20px 0",
  "@media(max-width: 600px)": { marginLeft: -30 }
});

const MapComp = ({ googleMaps, markerPos, zoom, center }) => {
  const markers = markerPos
    ? [
        {
          icon: mapMarker,
          position: markerPos
        }
      ]
    : [];
  const options = {
    gestureHandling: "greedy",
    scrollwheel: false
  };

  return (
    <div className={wrapper}>
      <GoogleMap
        googleMaps={googleMaps}
        coordinates={markers}
        center={center}
        zoom={zoom}
        autoFitBounds={true}
        boundsOffset={0.0005}
        options={options}
      />
    </div>
  );
};

const Map = props => {
  const apiKey = config("GOOGLE_API_KEY");
  return (
    <ReactGoogleMapLoader
      params={{
        key: apiKey, // Define your api key here
        libraries: "places"
      }}
      render={googleMaps =>
        googleMaps && <MapComp {...props} googleMaps={googleMaps} />
      }
    />
  );
};
export default Map;
